import styled from "styled-components/macro";
import { DeviceType } from "../../utils/hooks/useDeviceHook";
import { ProfileModalWrapper } from "../shared/Modal/Modal.styles";

export const ProfileAlabamaModalWrapper = styled.div<{
  deviceType: DeviceType;
}>`
  height: ${({ deviceType }) => (deviceType === "desktop" ? "auto" : "80%")};
  overflow: ${({ deviceType }) =>
    deviceType === "desktop" ? "hidden" : "scroll"};
  ${ProfileModalWrapper} {
    height: auto;
  }
`;

// These are now re-exported from Modal.styles - keeping only Alabama-specific components below

export const ProfileAlabamaModalInfoWrapper = styled.div`
  padding: 24px 24px;
`;

export const ProfileAlabamaModalInfo = styled.div`
  display: grid;
`;

export const ProfileAlabamaModalInfoDescription = styled.div`
  font-size: 16px;
  display: flex;

  span {
    font-weight: 700;
  }
`;

export const ProfileAlabamaModalInfoText = styled.div`
  font-size: 16px;
  margin-bottom: 10px;

  span {
    font-weight: 700;
  }
`;

export const ProfileAlabamaModalInfoTitle = styled.div`
  font-size: 18px;
  font-weight: 800;
  justify-content: center;
  display: flex;
  margin-top: 10px;
  margin-bottom: 20px;
`;

// All other components have been moved to their respective dedicated files
